import { createLazyComponent, LazyModule } from 'owa-bundling';
import { AgendaLoadingView } from 'owa-agenda-loading-events';

const lazyModule = new LazyModule(async () => {
    const lazyIndex = await import(/* webpackChunkName: "AgendaView" */ './lazyIndex');
    // initialize the agenda scenario
    lazyIndex.initializeAgenda();
    return lazyIndex;
});

export const AgendaView = createLazyComponent(lazyModule, m => m.AgendaView, AgendaLoadingView);
